import axios from 'axios';

let options = {
  apiBasePath: '/',
};

/**
 * Use specific settings if existant
 * else use default value => '/'
 *
 * TODO On n'a pas besoin de modifier le base path
 * TODO alors pourquoi rendre cela contribuable ?
 */
if (window.Drupal && window.Drupal.settings) {
  if (window.Drupal.settings.sante_resultats_edito) {
    options = window.Drupal.settings.sante_resultats_edito;
  } else if (window.Drupal.settings.sris_fakenews) {
    options = window.Drupal.settings.sris_fakenews;
  }
}

// eslint-disable-next-line import/prefer-default-export
export const HTTP = axios.create({
  baseURL: (options && options.apiBasePath) ? options.apiBasePath : '/',
  timeout: 60000,
});
